import React, { useCallback } from "react";
import { PanelContainer } from "./PanelContainer";
import { BookOpen } from "lucide-react";
import { useContentContext } from "@/components/content-chat/ContentContext";
import { ChaptersIntroScreen } from "@/components/chapters/ChaptersIntroScreen";
import { useContentNavigationOptional } from "@/context/ContentNavigationContext";

interface PanelProps {
  isMobile?: boolean;
  contentId?: string | null;
}

export const ChaptersPanel: React.FC<PanelProps> = (props) => {
  const { content } = useContentContext();
  const navigationContext = useContentNavigationOptional();

  const handleChapterClick = useCallback((chapter: { startPosition: number; endPosition: number; positionType: 'seconds' | 'pages' }) => {
    if (!navigationContext) return;
    
    if (chapter.positionType === 'pages') {
      navigationContext.navigateToPage(chapter.startPosition);
    } else {
      navigationContext.navigateToTimestamp(chapter.startPosition);
    }
  }, [navigationContext]);

  return (
    <PanelContainer
      {...props}
      title="Chapters"
      description={
        <>
          Try asking Shattara AI:{" "}
          <span className="font-bold">"Break this into chapters with page references."</span>
        </>
      }
      icon={<BookOpen className="h-4 w-4 text-primary" />}
    >
      <ChaptersIntroScreen 
        contentId={content?.id ?? props.contentId ?? null} 
        onChapterClick={handleChapterClick}
      />
    </PanelContainer>
  );
};
